<ftr-animated-remote
  [remote]="viewModel"
  [loadingTemplate]="loading"
  [failureTemplate]="failure"
  [emptyTemplate]="failure"
  [successTemplate]="success"
>
  <ng-template #loading>
    <ftr-line-loader message="Loading..."></ftr-line-loader>
  </ng-template>

  <ng-template #failure>
    <ftr-error-retry
      text="Failed to retrieve vocabulary. Please try again or contact the Court for advice."
      [icon]="false"
      (retry)="refreshSubject.next(undefined)"
    ></ftr-error-retry>
  </ng-template>

  <ng-template #success let-vm>
    <section class="sealing-toolbar">
      <div class="sealing-toolbar-buttons--dismiss">
        <a href="javascript: void(0)" (click)="cancel()" class="sealing-toolbar-buttons-button">
          <ftr-icon icon="Close" align="TextBottom"></ftr-icon>
        </a>
      </div>
      <div class="sealing-toolbar-label">
        <ftr-icon icon="Lock" color="Primary" align="Top"></ftr-icon>
        <span class="sealing-toolbar-label-text">{{ vm.terms.seal.singular | titlecase }} Content</span>
      </div>
      <ftr-legacy-time-range
        [control]="timeRangeControl"
        [allowedPrecision]="timeRangePrecision.Seconds"
        (onChange)="setSealingTimeRange($event)"
        [trackData]="true"
        [submitAttempted]="submitAttempted"
      ></ftr-legacy-time-range>
      <div class="sealing-toolbar-buttons">
        <div class="sealing-toolbar-buttons--seal-unseal">
          <a
            href="javascript: void(0)"
            ftrButton
            (click)="openSealingModal(sealModes.Seal)"
            class="sealing-toolbar-buttons-button sealing-toolbar-buttons--seal-unseal-button sealing-toolbar__seal"
          >
            <ftr-icon icon="Lock" align="TextBottom"></ftr-icon>
            <span class="sealing-toolbar-buttons--seal-unseal-button-text">{{
              vm.terms.seal.singular | titlecase
            }}</span>
          </a>
          <a
            href="javascript: void(0)"
            ftrButton
            [color]="buttonColor.Secondary"
            (click)="openSealingModal(sealModes.Unseal)"
            class="sealing-toolbar-buttons-button sealing-toolbar-buttons--seal-unseal-button sealing-toolbar__unseal"
          >
            <ftr-icon icon="Unlock" align="TextBottom"></ftr-icon>
            <span class="sealing-toolbar-buttons--seal-unseal-button-text">{{
              vm.terms.unseal.singular | titlecase
            }}</span>
          </a>
        </div>
        <div class="sealing-toolbar-buttons--cancel">
          <a
            ftrButton
            href="javascript: void(0)"
            (click)="cancel()"
            [displayType]="buttonDisplayType.Icon"
            class="sealing-toolbar-buttons-button sealing-toolbar__cancel"
          >
            <ftr-icon icon="Close" align="TextBottom"></ftr-icon>
          </a>
        </div>
      </div>

      <ftr-seal-unseal-modal
        [mode]="sealMode"
        [recordingId]="audioId"
        [courtSystemId]="courtSystemId"
        [isModalOpen$]="isModalOpen$"
        [sealingTimeRange]="sealingTimeRange"
        [terms]="vm.terms"
        (onSuccess)="onSuccessfulSeal()"
      >
      </ftr-seal-unseal-modal>
    </section>
  </ng-template>
</ftr-animated-remote>
